"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminCatalogueApi = exports.AdminCatalogueApiFactory = exports.AdminCatalogueApiFp = exports.AdminCatalogueApiAxiosParamCreator = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("../common");
// @ts-ignore
var base_1 = require("../base");
/**
 * AdminCatalogueApi - axios parameter creator
 * @export
 */
var AdminCatalogueApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Add liquidation on CatalogGroupProduct
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {string} catalogProductLogicId catalog product logic id
         * @param {LiquidationRequest} [liquidationRequest] Add liquidation on catalogGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLiquidationOnCatalogGroupProduct: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('addLiquidationOnCatalogGroupProduct', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('addLiquidationOnCatalogGroupProduct', 'catalogGroupLogicId', catalogGroupLogicId);
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('addLiquidationOnCatalogGroupProduct', 'catalogProductLogicId', catalogProductLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}/catalog-products/{catalogProductLogicId}/liquidations"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)))
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(liquidationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates and associate catalogAvailability to catalogGroupLogicId
         * @param {string} catalogLogicId
         * @param {string} catalogGroupLogicId
         * @param {string} catalogProductLogicId
         * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Creates and associate catalogAvailability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAndAssociateCatalogAvailability: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, catalogAvailabilityDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminCreateAndAssociateCatalogAvailability', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminCreateAndAssociateCatalogAvailability', 'catalogGroupLogicId', catalogGroupLogicId);
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminCreateAndAssociateCatalogAvailability', 'catalogProductLogicId', catalogProductLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}/catalog-products/{catalogProductLogicId}/catalog-availability"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)))
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogAvailabilityDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a catalogAvailability
         * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Creates a catalogAvailability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCatalogAvailability: function (catalogAvailabilityDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/catalog-availability";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogAvailabilityDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a catalogProduct-Sector
         * @param {CatalogProductSectorData} [catalogProductSectorData] Create initiative request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCatalogProductSector: function (catalogProductSectorData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/catalog/product/sector";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogProductSectorData, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a catalog product tag
         * @param {CatalogProductTagDto} [catalogProductTagDto] Create catalog product tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCatalogProductTag: function (catalogProductTagDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/catalog-product/tag";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogProductTagDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary delete catalog availability
         * @param {string} logicId logicId of the product catalog availability to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCatalogAvailability: function (logicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminDeleteCatalogAvailability', 'logicId', logicId);
                    localVarPath = "/admin/catalog-availability/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary delete catalog product sector
         * @param {string} catalogLogicId the logic id of the catalog
         * @param {string} sectorLogicId the logic id of the sector
         * @param {string} catalogProductLogicId the logic id of the catalog product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCatalogProductSector: function (catalogLogicId, sectorLogicId, catalogProductLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminDeleteCatalogProductSector', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'sectorLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminDeleteCatalogProductSector', 'sectorLogicId', sectorLogicId);
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminDeleteCatalogProductSector', 'catalogProductLogicId', catalogProductLogicId);
                    localVarPath = "/admin/catalog/{catalogLogicId}/catalog-product/{catalogProductLogicId}/sector/{sectorLogicId}"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("sectorLogicId", "}"), encodeURIComponent(String(sectorLogicId)))
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary delete catalog product tag
         * @param {string} catalogProductLogicId logicId of the catalog product tag
         * @param {string} tagLogicId logicId of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCatalogProductTag: function (catalogProductLogicId, tagLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminDeleteCatalogProductTag', 'catalogProductLogicId', catalogProductLogicId);
                    // verify required parameter 'tagLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminDeleteCatalogProductTag', 'tagLogicId', tagLogicId);
                    localVarPath = "/admin/catalog-product/{catalogProductLogicId}/tag/{tagLogicId}"
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)))
                        .replace("{".concat("tagLogicId", "}"), encodeURIComponent(String(tagLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves catalog availability
         * @param {string} logicId the logic id of the catalog availability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCatalogAvailability: function (logicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminGetCatalogAvailability', 'logicId', logicId);
                    localVarPath = "/admin/catalog-availability/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves single catalog sector product
         * @param {string} catalogLogicId the logic id of the catalog
         * @param {string} sectorLogicId the logic id of the sector
         * @param {string} catalogProductLogicId the logic id of the catalog product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCatalogProductSector: function (catalogLogicId, sectorLogicId, catalogProductLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminGetCatalogProductSector', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'sectorLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminGetCatalogProductSector', 'sectorLogicId', sectorLogicId);
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminGetCatalogProductSector', 'catalogProductLogicId', catalogProductLogicId);
                    localVarPath = "/admin/catalog/{catalogLogicId}/catalog-product/{catalogProductLogicId}/sector/{sectorLogicId}"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("sectorLogicId", "}"), encodeURIComponent(String(sectorLogicId)))
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves single catalog product tag
         * @param {string} catalogProductLogicId the logic id of the catalog product
         * @param {string} tagLogicId the logic id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCatalogProductTag: function (catalogProductLogicId, tagLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminGetCatalogProductTag', 'catalogProductLogicId', catalogProductLogicId);
                    // verify required parameter 'tagLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminGetCatalogProductTag', 'tagLogicId', tagLogicId);
                    localVarPath = "/admin/catalog-product/{catalogProductLogicId}/tag/{tagLogicId}"
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)))
                        .replace("{".concat("tagLogicId", "}"), encodeURIComponent(String(tagLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary search a catalog availability
         * @param {Array<string>} [logicId] search a catalog availability
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCatalogAvailability: function (logicId, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/catalog-availability";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (logicId) {
                        localVarQueryParameter['logicId'] = logicId.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary get catalog product tag
         * @param {Array<string>} [catalogProductLogicId] the logic id of the catalog product
         * @param {Array<string>} [tagLogicId] the logic id of the tag
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCatalogProductTag: function (catalogProductLogicId, tagLogicId, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/catalog-product/tag";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (catalogProductLogicId) {
                        localVarQueryParameter['catalogProductLogicId'] = catalogProductLogicId.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (tagLogicId) {
                        localVarQueryParameter['tagLogicId'] = tagLogicId.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary search catalog sector product
         * @param {Array<string>} [catalogLogicId] the logic id of the catalog
         * @param {Array<string>} [catalogProductLogicId] the logic id of the catalog product
         * @param {Array<string>} [sectorLogicId] the logic id of the catalog sector
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCatalogSectorProduct: function (catalogLogicId, catalogProductLogicId, sectorLogicId, page, size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/catalog/product/sector";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (catalogLogicId) {
                        localVarQueryParameter['catalogLogicId'] = catalogLogicId.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (catalogProductLogicId) {
                        localVarQueryParameter['catalogProductLogicId'] = catalogProductLogicId.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (sectorLogicId) {
                        localVarQueryParameter['sectorLogicId'] = sectorLogicId.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary update catalog availability
         * @param {string} logicId logicId of the product catalog availability to update
         * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Update supplier request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCatalogAvailability: function (logicId, catalogAvailabilityDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'logicId' is not null or undefined
                    (0, common_1.assertParamExists)('adminUpdateCatalogAvailability', 'logicId', logicId);
                    localVarPath = "/admin/catalog-availability/{logicId}"
                        .replace("{".concat("logicId", "}"), encodeURIComponent(String(logicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogAvailabilityDto, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a catalog
         * @param {CatalogCreateRequest} [catalogCreateRequest] Create catalog request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalog: function (catalogCreateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/catalogs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogCreateRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a catalogGroup
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogGroupCreateRequest} [catalogGroupCreateRequest] Create catalogGroup request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogGroup: function (catalogLogicId, catalogGroupCreateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('createCatalogGroup', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogGroupCreateRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a catalog/project association
         * @param {string} projectLogicId project logic id
         * @param {CatalogProjectAssociationRequest} [catalogProjectAssociationRequest] Create catalog/project association request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogProjectAssociation: function (projectLogicId, catalogProjectAssociationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'projectLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('createCatalogProjectAssociation', 'projectLogicId', projectLogicId);
                    localVarPath = "/admin/projects/{projectLogicId}/catalogs"
                        .replace("{".concat("projectLogicId", "}"), encodeURIComponent(String(projectLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogProjectAssociationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a catalog/sector association
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogSectorAssociationRequest} [catalogSectorAssociationRequest] Create catalogSector request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogSectorAssociation: function (catalogLogicId, catalogSectorAssociationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('createCatalogSectorAssociation', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-sectors"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogSectorAssociationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a courierTenantProjectPartners
         * @param {CreateCourierTenantProjectPartnerMassiveRequest} [createCourierTenantProjectPartnerMassiveRequest] Create courierTenantProject request (Massive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourierTenantProjectPartners: function (createCourierTenantProjectPartnerMassiveRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/courier-tenant-project-partners";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createCourierTenantProjectPartnerMassiveRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a PricingModel
         * @param {PricingModelRequest} [pricingModelRequest] Create PricingModel request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPricingModel: function (pricingModelRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/pricing-models";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pricingModelRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a sector
         * @param {CreateSectorRequest} [createSectorRequest] Create sector request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSector: function (createSectorRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/sectors";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSectorRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a shippingAvailabilityConfig
         * @param {CreateShippingAvailabilityConfigRequest} [createShippingAvailabilityConfigRequest] Create shippingAvailabilityConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShippingAvailabilityConfig: function (createShippingAvailabilityConfigRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/shipping-availability-configs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShippingAvailabilityConfigRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a shippingAvailabilityPartnerConfig
         * @param {CreateShippingAvailabilityPartnerConfigRequest} [createShippingAvailabilityPartnerConfigRequest] Create shippingAvailabilityPartnerConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShippingAvailabilityPartnerConfig: function (createShippingAvailabilityPartnerConfigRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/shipping-availability-partner-configs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShippingAvailabilityPartnerConfigRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a shippingAvailabilityProductConfig
         * @param {CreateShippingAvailabilityProductConfigRequest} [createShippingAvailabilityProductConfigRequest] Create shippingAvailabilityProductConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShippingAvailabilityProductConfig: function (createShippingAvailabilityProductConfigRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/shipping-availability-product-configs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShippingAvailabilityProductConfigRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creates a tag
         * @param {CreateTagRequest} [createTagRequest] Create tag request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag: function (createTagRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/tags";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTagRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a catalog if no longer in use
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalog: function (catalogLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCatalog', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a catalogGroup if there are no products associated
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogGroup: function (catalogGroupLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCatalogGroup', 'catalogGroupLogicId', catalogGroupLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}"
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary delete existing liquidation linked to a specific catalog group product
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {string} catalogProductLogicId catalog product logic id
         * @param {string} liquidationLogicId liquidation logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogGroupProductLiquidation: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCatalogGroupProductLiquidation', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCatalogGroupProductLiquidation', 'catalogGroupLogicId', catalogGroupLogicId);
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCatalogGroupProductLiquidation', 'catalogProductLogicId', catalogProductLogicId);
                    // verify required parameter 'liquidationLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCatalogGroupProductLiquidation', 'liquidationLogicId', liquidationLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}/catalog-products/{catalogProductLogicId}/liquidations/{liquidationLogicId}"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)))
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)))
                        .replace("{".concat("liquidationLogicId", "}"), encodeURIComponent(String(liquidationLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a catalog/project association
         * @param {string} projectLogicId project logic id
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogProjectAssociation: function (projectLogicId, catalogLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'projectLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCatalogProjectAssociation', 'projectLogicId', projectLogicId);
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCatalogProjectAssociation', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/projects/{projectLogicId}/catalogs/{catalogLogicId}"
                        .replace("{".concat("projectLogicId", "}"), encodeURIComponent(String(projectLogicId)))
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a catalogSector if no longer in use
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogSectorLogicId catalog-sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogSectorAssociation: function (catalogLogicId, catalogSectorLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCatalogSectorAssociation', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogSectorLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCatalogSectorAssociation', 'catalogSectorLogicId', catalogSectorLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-sectors/{catalogSectorLogicId}"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("catalogSectorLogicId", "}"), encodeURIComponent(String(catalogSectorLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a courierTenantProject if there are no associated
         * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCourierTenantProjectPartner: function (courierTenantProjectLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'courierTenantProjectLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteCourierTenantProjectPartner', 'courierTenantProjectLogicId', courierTenantProjectLogicId);
                    localVarPath = "/admin/courier-tenant-project-partners/{courierTenantProjectLogicId}"
                        .replace("{".concat("courierTenantProjectLogicId", "}"), encodeURIComponent(String(courierTenantProjectLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Delete resource if unrelated
         * @param {string} pricingModelLogicId PricingModel logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePricingModel: function (pricingModelLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pricingModelLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deletePricingModel', 'pricingModelLogicId', pricingModelLogicId);
                    localVarPath = "/admin/pricing-models/{pricingModelLogicId}"
                        .replace("{".concat("pricingModelLogicId", "}"), encodeURIComponent(String(pricingModelLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a sector if there are no products associated
         * @param {string} sectorLogicId sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSector: function (sectorLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sectorLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteSector', 'sectorLogicId', sectorLogicId);
                    localVarPath = "/admin/sectors/{sectorLogicId}"
                        .replace("{".concat("sectorLogicId", "}"), encodeURIComponent(String(sectorLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a shippingAvailabilityConfig if there are no associated
         * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShippingAvailabilityConfig: function (shippingAvailabilityConfigLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shippingAvailabilityConfigLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteShippingAvailabilityConfig', 'shippingAvailabilityConfigLogicId', shippingAvailabilityConfigLogicId);
                    localVarPath = "/admin/shipping-availability-configs/{shippingAvailabilityConfigLogicId}"
                        .replace("{".concat("shippingAvailabilityConfigLogicId", "}"), encodeURIComponent(String(shippingAvailabilityConfigLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a shippingAvailabilityPartnerConfig if there are no associated
         * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShippingAvailabilityPartnerConfig: function (shippingAvailabilityPartnerConfigLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shippingAvailabilityPartnerConfigLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteShippingAvailabilityPartnerConfig', 'shippingAvailabilityPartnerConfigLogicId', shippingAvailabilityPartnerConfigLogicId);
                    localVarPath = "/admin/shipping-availability-partner-configs/{shippingAvailabilityPartnerConfigLogicId}"
                        .replace("{".concat("shippingAvailabilityPartnerConfigLogicId", "}"), encodeURIComponent(String(shippingAvailabilityPartnerConfigLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a shippingAvailabilityProductConfig if there are no associated
         * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShippingAvailabilityProductConfig: function (shippingAvailabilityProductConfigLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shippingAvailabilityProductConfigLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteShippingAvailabilityProductConfig', 'shippingAvailabilityProductConfigLogicId', shippingAvailabilityProductConfigLogicId);
                    localVarPath = "/admin/shipping-availability-product-configs/{shippingAvailabilityProductConfigLogicId}"
                        .replace("{".concat("shippingAvailabilityProductConfigLogicId", "}"), encodeURIComponent(String(shippingAvailabilityProductConfigLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Deletes a tag if there are no products associated
         * @param {string} tagLogicId tag logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag: function (tagLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'tagLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('deleteTag', 'tagLogicId', tagLogicId);
                    localVarPath = "/admin/tags/{tagLogicId}"
                        .replace("{".concat("tagLogicId", "}"), encodeURIComponent(String(tagLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalog
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalog: function (catalogLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalog', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalogGroup
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGroup: function (catalogGroupLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogGroup', 'catalogGroupLogicId', catalogGroupLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}"
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalogGroup products
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGroupProducts: function (catalogLogicId, catalogGroupLogicId, page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogGroupProducts', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogGroupProducts', 'catalogGroupLogicId', catalogGroupLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}/products"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged catalogGroups filtered by input parameters
         * @param {string} catalogLogicId catalog logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGroups: function (catalogLogicId, page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogGroups', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalogProduct
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogProductLogicId catalogProduct logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogProduct: function (catalogLogicId, catalogProductLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogProduct', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogProduct', 'catalogProductLogicId', catalogProductLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-products/{catalogProductLogicId}"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged catalogProducts filtered by input parameters
         * @param {string} catalogLogicId catalog logic id
         * @param {Array<string>} [notInCatalogGroupLogicIds] list of catalog-groups (logicId) to exclude
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogProducts: function (catalogLogicId, notInCatalogGroupLogicIds, page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogProducts', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-products"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (notInCatalogGroupLogicIds) {
                        localVarQueryParameter['notInCatalogGroupLogicIds'] = notInCatalogGroupLogicIds.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalog/project association
         * @param {string} projectLogicId project logic id
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogProjectAssociation: function (projectLogicId, catalogLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'projectLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogProjectAssociation', 'projectLogicId', projectLogicId);
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogProjectAssociation', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/projects/{projectLogicId}/catalogs/{catalogLogicId}"
                        .replace("{".concat("projectLogicId", "}"), encodeURIComponent(String(projectLogicId)))
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalogSector
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogSectorLogicId catalog-sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogSector: function (catalogLogicId, catalogSectorLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogSector', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogSectorLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogSector', 'catalogSectorLogicId', catalogSectorLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-sectors/{catalogSectorLogicId}"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("catalogSectorLogicId", "}"), encodeURIComponent(String(catalogSectorLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged catalogSectors filtered by input parameters
         * @param {string} catalogLogicId catalog logic id
         * @param {string} [sectorLogicId] sector logic id
         * @param {string} [sectorParentLogicId] sector parent logic id
         * @param {string} [catalogSectorLogicId] catalog-sector logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogSectors: function (catalogLogicId, sectorLogicId, sectorParentLogicId, catalogSectorLogicId, page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogSectors', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-sectors"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (sectorLogicId !== undefined) {
                        localVarQueryParameter['sectorLogicId'] = sectorLogicId;
                    }
                    if (sectorParentLogicId !== undefined) {
                        localVarQueryParameter['sectorParentLogicId'] = sectorParentLogicId;
                    }
                    if (catalogSectorLogicId !== undefined) {
                        localVarQueryParameter['catalogSectorLogicId'] = catalogSectorLogicId;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged catalogs filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogs: function (page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/catalogs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged catalogs filtered by input parameters
         * @param {string} projectLogicId project logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogsProjectAssociation: function (projectLogicId, page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'projectLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getCatalogsProjectAssociation', 'projectLogicId', projectLogicId);
                    localVarPath = "/admin/projects/{projectLogicId}/catalogs"
                        .replace("{".concat("projectLogicId", "}"), encodeURIComponent(String(projectLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a sector
         * @param {string} sectorLogicId sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSector: function (sectorLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sectorLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getSector', 'sectorLogicId', sectorLogicId);
                    localVarPath = "/admin/sectors/{sectorLogicId}"
                        .replace("{".concat("sectorLogicId", "}"), encodeURIComponent(String(sectorLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged sectors filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectors: function (page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/sectors";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a tag
         * @param {string} tagLogicId tag logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag: function (tagLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'tagLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('getTag', 'tagLogicId', tagLogicId);
                    localVarPath = "/admin/tags/{tagLogicId}"
                        .replace("{".concat("tagLogicId", "}"), encodeURIComponent(String(tagLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged tags filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: function (page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/tags";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a courierTenantProjectPartner
         * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadCourierTenantProjectPartner: function (courierTenantProjectLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'courierTenantProjectLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('loadCourierTenantProjectPartner', 'courierTenantProjectLogicId', courierTenantProjectLogicId);
                    localVarPath = "/admin/courier-tenant-project-partners/{courierTenantProjectLogicId}"
                        .replace("{".concat("courierTenantProjectLogicId", "}"), encodeURIComponent(String(courierTenantProjectLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a pricingModel
         * @param {string} pricingModelLogicId PricingModel logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadPricingModel: function (pricingModelLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pricingModelLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('loadPricingModel', 'pricingModelLogicId', pricingModelLogicId);
                    localVarPath = "/admin/pricing-models/{pricingModelLogicId}"
                        .replace("{".concat("pricingModelLogicId", "}"), encodeURIComponent(String(pricingModelLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a shippingAvailabilityConfig
         * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadShippingAvailabilityConfig: function (shippingAvailabilityConfigLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shippingAvailabilityConfigLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('loadShippingAvailabilityConfig', 'shippingAvailabilityConfigLogicId', shippingAvailabilityConfigLogicId);
                    localVarPath = "/admin/shipping-availability-configs/{shippingAvailabilityConfigLogicId}"
                        .replace("{".concat("shippingAvailabilityConfigLogicId", "}"), encodeURIComponent(String(shippingAvailabilityConfigLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a shippingAvailabilityPartnerConfig
         * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadShippingAvailabilityPartnerConfig: function (shippingAvailabilityPartnerConfigLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shippingAvailabilityPartnerConfigLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('loadShippingAvailabilityPartnerConfig', 'shippingAvailabilityPartnerConfigLogicId', shippingAvailabilityPartnerConfigLogicId);
                    localVarPath = "/admin/shipping-availability-partner-configs/{shippingAvailabilityPartnerConfigLogicId}"
                        .replace("{".concat("shippingAvailabilityPartnerConfigLogicId", "}"), encodeURIComponent(String(shippingAvailabilityPartnerConfigLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a shippingAvailabilityProductConfig
         * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadShippingAvailabilityProductConfig: function (shippingAvailabilityProductConfigLogicId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shippingAvailabilityProductConfigLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('loadShippingAvailabilityProductConfig', 'shippingAvailabilityProductConfigLogicId', shippingAvailabilityProductConfigLogicId);
                    localVarPath = "/admin/shipping-availability-product-configs/{shippingAvailabilityProductConfigLogicId}"
                        .replace("{".concat("shippingAvailabilityProductConfigLogicId", "}"), encodeURIComponent(String(shippingAvailabilityProductConfigLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary modify status for a specific catalogGroup
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {CatalogGroupStatusRequest} catalogGroupStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCatalogGroupStatus: function (catalogGroupLogicId, catalogGroupStatusRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('patchCatalogGroupStatus', 'catalogGroupLogicId', catalogGroupLogicId);
                    // verify required parameter 'catalogGroupStatusRequest' is not null or undefined
                    (0, common_1.assertParamExists)('patchCatalogGroupStatus', 'catalogGroupStatusRequest', catalogGroupStatusRequest);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}/status"
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogGroupStatusRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary modify status for a specific catalog
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogStatusRequest} catalogStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCatalogStatus: function (catalogLogicId, catalogStatusRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('patchCatalogStatus', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogStatusRequest' is not null or undefined
                    (0, common_1.assertParamExists)('patchCatalogStatus', 'catalogStatusRequest', catalogStatusRequest);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/status"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogStatusRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged courierTenantProjectPartner filtered by input parameters
         * @param {string} tenantLogicId tenant logic id
         * @param {string} projectLogicId project logic id
         * @param {string} [courierLogicId] courier logic id
         * @param {string} [partnerLogicId] partner logic id
         * @param {string} [nationCode] nationCode
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCourierTenantProjectPartners: function (tenantLogicId, projectLogicId, courierLogicId, partnerLogicId, nationCode, page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'tenantLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('searchCourierTenantProjectPartners', 'tenantLogicId', tenantLogicId);
                    // verify required parameter 'projectLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('searchCourierTenantProjectPartners', 'projectLogicId', projectLogicId);
                    localVarPath = "/admin/courier-tenant-project-partners";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (tenantLogicId !== undefined) {
                        localVarQueryParameter['tenantLogicId'] = tenantLogicId;
                    }
                    if (projectLogicId !== undefined) {
                        localVarQueryParameter['projectLogicId'] = projectLogicId;
                    }
                    if (courierLogicId !== undefined) {
                        localVarQueryParameter['courierLogicId'] = courierLogicId;
                    }
                    if (partnerLogicId !== undefined) {
                        localVarQueryParameter['partnerLogicId'] = partnerLogicId;
                    }
                    if (nationCode !== undefined) {
                        localVarQueryParameter['nationCode'] = nationCode;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary search couriers
         * @param {string} [courierLogicId] courier logic ids
         * @param {string} [nationCode] nationCode to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCouriers: function (courierLogicId, nationCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/couriers";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (courierLogicId !== undefined) {
                        localVarQueryParameter['courierLogicId'] = courierLogicId;
                    }
                    if (nationCode !== undefined) {
                        localVarQueryParameter['nationCode'] = nationCode;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged pricingModels filtered by input parameters
         * @param {PricingModelTypeEnum} [type] type of the pricingModel param
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPricingModels: function (type, page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/pricing-models";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged shippingAvailabilityConfigs filtered by input parameters
         * @param {string} [tenantLogicId] tenant logic id
         * @param {string} [projectLogicId] project logic id
         * @param {string} [catalogLogicId] catalog logic id
         * @param {Set<string>} [inProductLogicIds] list of product (logicId) to include
         * @param {Set<string>} [inPartnerLogicIds] list of partner (logicId) to include
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchShippingAvailabilityConfigs: function (tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, inPartnerLogicIds, page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/shipping-availability-configs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (tenantLogicId !== undefined) {
                        localVarQueryParameter['tenantLogicId'] = tenantLogicId;
                    }
                    if (projectLogicId !== undefined) {
                        localVarQueryParameter['projectLogicId'] = projectLogicId;
                    }
                    if (catalogLogicId !== undefined) {
                        localVarQueryParameter['catalogLogicId'] = catalogLogicId;
                    }
                    if (inProductLogicIds) {
                        localVarQueryParameter['inProductLogicIds'] = Array.from(inProductLogicIds).join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (inPartnerLogicIds) {
                        localVarQueryParameter['inPartnerLogicIds'] = Array.from(inPartnerLogicIds).join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged shippingAvailabilityPartnerConfigs filtered by input parameters
         * @param {string} [tenantLogicId] tenant logic id
         * @param {string} [projectLogicId] project logic id
         * @param {string} [catalogLogicId] catalog logic id
         * @param {Set<string>} [inPartnerLogicIds] list of partner (logicId) to include
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchShippingAvailabilityPartnerConfigs: function (tenantLogicId, projectLogicId, catalogLogicId, inPartnerLogicIds, page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/shipping-availability-partner-configs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (tenantLogicId !== undefined) {
                        localVarQueryParameter['tenantLogicId'] = tenantLogicId;
                    }
                    if (projectLogicId !== undefined) {
                        localVarQueryParameter['projectLogicId'] = projectLogicId;
                    }
                    if (catalogLogicId !== undefined) {
                        localVarQueryParameter['catalogLogicId'] = catalogLogicId;
                    }
                    if (inPartnerLogicIds) {
                        localVarQueryParameter['inPartnerLogicIds'] = Array.from(inPartnerLogicIds).join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves paged shippingAvailabilityProductConfigs filtered by input parameters
         * @param {string} [tenantLogicId] tenant logic id
         * @param {string} [projectLogicId] project logic id
         * @param {string} [catalogLogicId] catalog logic id
         * @param {Set<string>} [inProductLogicIds] list of product (logicId) to include
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchShippingAvailabilityProductConfigs: function (tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, page, size, includeMetadata, sort, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/admin/shipping-availability-product-configs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (tenantLogicId !== undefined) {
                        localVarQueryParameter['tenantLogicId'] = tenantLogicId;
                    }
                    if (projectLogicId !== undefined) {
                        localVarQueryParameter['projectLogicId'] = projectLogicId;
                    }
                    if (catalogLogicId !== undefined) {
                        localVarQueryParameter['catalogLogicId'] = catalogLogicId;
                    }
                    if (inProductLogicIds) {
                        localVarQueryParameter['inProductLogicIds'] = Array.from(inProductLogicIds).join(base_1.COLLECTION_FORMATS.csv);
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (includeMetadata !== undefined) {
                        localVarQueryParameter['includeMetadata'] = includeMetadata;
                    }
                    if (sort) {
                        localVarQueryParameter['sort'] = sort.join(base_1.COLLECTION_FORMATS.csv);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates the billing id of a catalogTenantProject entity
         * @param {string} projectLogicId project logic id
         * @param {CatalogProjectAssociationRequest} [catalogProjectAssociationRequest] Create catalog/project association request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingCatalogProjectTenant: function (projectLogicId, catalogProjectAssociationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'projectLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateBillingCatalogProjectTenant', 'projectLogicId', projectLogicId);
                    localVarPath = "/admin/projects/{projectLogicId}/catalogs/billingId"
                        .replace("{".concat("projectLogicId", "}"), encodeURIComponent(String(projectLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogProjectAssociationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a catalog
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogUpdateRequest} [catalogUpdateRequest] Update catalog request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalog: function (catalogLogicId, catalogUpdateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCatalog', 'catalogLogicId', catalogLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogUpdateRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a catalogGroup
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {CatalogGroupUpdateRequest} [catalogGroupUpdateRequest] Update catalogGroup request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogGroup: function (catalogGroupLogicId, catalogGroupUpdateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCatalogGroup', 'catalogGroupLogicId', catalogGroupLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}"
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(catalogGroupUpdateRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary update existing liquidation linked to a specific catalog group product
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {string} catalogProductLogicId catalog product logic id
         * @param {string} liquidationLogicId liquidation logic id
         * @param {LiquidationRequest} [liquidationRequest] Update liquidation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogGroupProductLiquidation: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, liquidationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'catalogLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCatalogGroupProductLiquidation', 'catalogLogicId', catalogLogicId);
                    // verify required parameter 'catalogGroupLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCatalogGroupProductLiquidation', 'catalogGroupLogicId', catalogGroupLogicId);
                    // verify required parameter 'catalogProductLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCatalogGroupProductLiquidation', 'catalogProductLogicId', catalogProductLogicId);
                    // verify required parameter 'liquidationLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCatalogGroupProductLiquidation', 'liquidationLogicId', liquidationLogicId);
                    localVarPath = "/admin/catalogs/{catalogLogicId}/catalog-groups/{catalogGroupLogicId}/catalog-products/{catalogProductLogicId}/liquidations/{liquidationLogicId}"
                        .replace("{".concat("catalogLogicId", "}"), encodeURIComponent(String(catalogLogicId)))
                        .replace("{".concat("catalogGroupLogicId", "}"), encodeURIComponent(String(catalogGroupLogicId)))
                        .replace("{".concat("catalogProductLogicId", "}"), encodeURIComponent(String(catalogProductLogicId)))
                        .replace("{".concat("liquidationLogicId", "}"), encodeURIComponent(String(liquidationLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(liquidationRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a courierTenantProjectPartner
         * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
         * @param {UpdateCourierTenantProjectPartnerRequest} [updateCourierTenantProjectPartnerRequest] Update courierTenantProject request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCourierTenantProjectPartner: function (courierTenantProjectLogicId, updateCourierTenantProjectPartnerRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'courierTenantProjectLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCourierTenantProjectPartner', 'courierTenantProjectLogicId', courierTenantProjectLogicId);
                    localVarPath = "/admin/courier-tenant-project-partners/{courierTenantProjectLogicId}"
                        .replace("{".concat("courierTenantProjectLogicId", "}"), encodeURIComponent(String(courierTenantProjectLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCourierTenantProjectPartnerRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a pricingModel
         * @param {string} pricingModelLogicId PricingModel logic id
         * @param {PricingModelRequest} [pricingModelRequest] Update pricingModel request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePricingModel: function (pricingModelLogicId, pricingModelRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'pricingModelLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updatePricingModel', 'pricingModelLogicId', pricingModelLogicId);
                    localVarPath = "/admin/pricing-models/{pricingModelLogicId}"
                        .replace("{".concat("pricingModelLogicId", "}"), encodeURIComponent(String(pricingModelLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pricingModelRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a sector
         * @param {string} sectorLogicId sector logic id
         * @param {UpdateSectorRequest} [updateSectorRequest] Update sector request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSector: function (sectorLogicId, updateSectorRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'sectorLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateSector', 'sectorLogicId', sectorLogicId);
                    localVarPath = "/admin/sectors/{sectorLogicId}"
                        .replace("{".concat("sectorLogicId", "}"), encodeURIComponent(String(sectorLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSectorRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a shippingAvailabilityConfig
         * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
         * @param {UpdateShippingAvailabilityConfigRequest} [updateShippingAvailabilityConfigRequest] Update shippingAvailabilityConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAvailabilityConfig: function (shippingAvailabilityConfigLogicId, updateShippingAvailabilityConfigRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shippingAvailabilityConfigLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateShippingAvailabilityConfig', 'shippingAvailabilityConfigLogicId', shippingAvailabilityConfigLogicId);
                    localVarPath = "/admin/shipping-availability-configs/{shippingAvailabilityConfigLogicId}"
                        .replace("{".concat("shippingAvailabilityConfigLogicId", "}"), encodeURIComponent(String(shippingAvailabilityConfigLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateShippingAvailabilityConfigRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a shippingAvailabilityPartnerConfig
         * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
         * @param {UpdateShippingAvailabilityPartnerConfigRequest} [updateShippingAvailabilityPartnerConfigRequest] Update shippingAvailabilityPartnerConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAvailabilityPartnerConfig: function (shippingAvailabilityPartnerConfigLogicId, updateShippingAvailabilityPartnerConfigRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shippingAvailabilityPartnerConfigLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateShippingAvailabilityPartnerConfig', 'shippingAvailabilityPartnerConfigLogicId', shippingAvailabilityPartnerConfigLogicId);
                    localVarPath = "/admin/shipping-availability-partner-configs/{shippingAvailabilityPartnerConfigLogicId}"
                        .replace("{".concat("shippingAvailabilityPartnerConfigLogicId", "}"), encodeURIComponent(String(shippingAvailabilityPartnerConfigLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateShippingAvailabilityPartnerConfigRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Updates a shippingAvailabilityProductConfig
         * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
         * @param {UpdateShippingAvailabilityProductConfigRequest} [updateShippingAvailabilityProductConfigRequest] Update shippingAvailabilityProductConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAvailabilityProductConfig: function (shippingAvailabilityProductConfigLogicId, updateShippingAvailabilityProductConfigRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shippingAvailabilityProductConfigLogicId' is not null or undefined
                    (0, common_1.assertParamExists)('updateShippingAvailabilityProductConfig', 'shippingAvailabilityProductConfigLogicId', shippingAvailabilityProductConfigLogicId);
                    localVarPath = "/admin/shipping-availability-product-configs/{shippingAvailabilityProductConfigLogicId}"
                        .replace("{".concat("shippingAvailabilityProductConfigLogicId", "}"), encodeURIComponent(String(shippingAvailabilityProductConfigLogicId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateShippingAvailabilityProductConfigRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AdminCatalogueApiAxiosParamCreator = AdminCatalogueApiAxiosParamCreator;
/**
 * AdminCatalogueApi - functional programming interface
 * @export
 */
var AdminCatalogueApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AdminCatalogueApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Add liquidation on CatalogGroupProduct
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {string} catalogProductLogicId catalog product logic id
         * @param {LiquidationRequest} [liquidationRequest] Add liquidation on catalogGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLiquidationOnCatalogGroupProduct: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addLiquidationOnCatalogGroupProduct(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates and associate catalogAvailability to catalogGroupLogicId
         * @param {string} catalogLogicId
         * @param {string} catalogGroupLogicId
         * @param {string} catalogProductLogicId
         * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Creates and associate catalogAvailability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAndAssociateCatalogAvailability: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, catalogAvailabilityDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateAndAssociateCatalogAvailability(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, catalogAvailabilityDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a catalogAvailability
         * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Creates a catalogAvailability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCatalogAvailability: function (catalogAvailabilityDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateCatalogAvailability(catalogAvailabilityDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a catalogProduct-Sector
         * @param {CatalogProductSectorData} [catalogProductSectorData] Create initiative request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCatalogProductSector: function (catalogProductSectorData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateCatalogProductSector(catalogProductSectorData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a catalog product tag
         * @param {CatalogProductTagDto} [catalogProductTagDto] Create catalog product tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCatalogProductTag: function (catalogProductTagDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminCreateCatalogProductTag(catalogProductTagDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary delete catalog availability
         * @param {string} logicId logicId of the product catalog availability to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCatalogAvailability: function (logicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteCatalogAvailability(logicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary delete catalog product sector
         * @param {string} catalogLogicId the logic id of the catalog
         * @param {string} sectorLogicId the logic id of the sector
         * @param {string} catalogProductLogicId the logic id of the catalog product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCatalogProductSector: function (catalogLogicId, sectorLogicId, catalogProductLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteCatalogProductSector(catalogLogicId, sectorLogicId, catalogProductLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary delete catalog product tag
         * @param {string} catalogProductLogicId logicId of the catalog product tag
         * @param {string} tagLogicId logicId of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCatalogProductTag: function (catalogProductLogicId, tagLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminDeleteCatalogProductTag(catalogProductLogicId, tagLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves catalog availability
         * @param {string} logicId the logic id of the catalog availability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCatalogAvailability: function (logicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetCatalogAvailability(logicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves single catalog sector product
         * @param {string} catalogLogicId the logic id of the catalog
         * @param {string} sectorLogicId the logic id of the sector
         * @param {string} catalogProductLogicId the logic id of the catalog product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCatalogProductSector: function (catalogLogicId, sectorLogicId, catalogProductLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetCatalogProductSector(catalogLogicId, sectorLogicId, catalogProductLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves single catalog product tag
         * @param {string} catalogProductLogicId the logic id of the catalog product
         * @param {string} tagLogicId the logic id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCatalogProductTag: function (catalogProductLogicId, tagLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminGetCatalogProductTag(catalogProductLogicId, tagLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary search a catalog availability
         * @param {Array<string>} [logicId] search a catalog availability
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCatalogAvailability: function (logicId, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminSearchCatalogAvailability(logicId, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary get catalog product tag
         * @param {Array<string>} [catalogProductLogicId] the logic id of the catalog product
         * @param {Array<string>} [tagLogicId] the logic id of the tag
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCatalogProductTag: function (catalogProductLogicId, tagLogicId, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminSearchCatalogProductTag(catalogProductLogicId, tagLogicId, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary search catalog sector product
         * @param {Array<string>} [catalogLogicId] the logic id of the catalog
         * @param {Array<string>} [catalogProductLogicId] the logic id of the catalog product
         * @param {Array<string>} [sectorLogicId] the logic id of the catalog sector
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCatalogSectorProduct: function (catalogLogicId, catalogProductLogicId, sectorLogicId, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminSearchCatalogSectorProduct(catalogLogicId, catalogProductLogicId, sectorLogicId, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary update catalog availability
         * @param {string} logicId logicId of the product catalog availability to update
         * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Update supplier request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCatalogAvailability: function (logicId, catalogAvailabilityDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.adminUpdateCatalogAvailability(logicId, catalogAvailabilityDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a catalog
         * @param {CatalogCreateRequest} [catalogCreateRequest] Create catalog request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalog: function (catalogCreateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCatalog(catalogCreateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a catalogGroup
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogGroupCreateRequest} [catalogGroupCreateRequest] Create catalogGroup request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogGroup: function (catalogLogicId, catalogGroupCreateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCatalogGroup(catalogLogicId, catalogGroupCreateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a catalog/project association
         * @param {string} projectLogicId project logic id
         * @param {CatalogProjectAssociationRequest} [catalogProjectAssociationRequest] Create catalog/project association request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogProjectAssociation: function (projectLogicId, catalogProjectAssociationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCatalogProjectAssociation(projectLogicId, catalogProjectAssociationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a catalog/sector association
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogSectorAssociationRequest} [catalogSectorAssociationRequest] Create catalogSector request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogSectorAssociation: function (catalogLogicId, catalogSectorAssociationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCatalogSectorAssociation(catalogLogicId, catalogSectorAssociationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a courierTenantProjectPartners
         * @param {CreateCourierTenantProjectPartnerMassiveRequest} [createCourierTenantProjectPartnerMassiveRequest] Create courierTenantProject request (Massive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourierTenantProjectPartners: function (createCourierTenantProjectPartnerMassiveRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createCourierTenantProjectPartners(createCourierTenantProjectPartnerMassiveRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a PricingModel
         * @param {PricingModelRequest} [pricingModelRequest] Create PricingModel request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPricingModel: function (pricingModelRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPricingModel(pricingModelRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a sector
         * @param {CreateSectorRequest} [createSectorRequest] Create sector request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSector: function (createSectorRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSector(createSectorRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a shippingAvailabilityConfig
         * @param {CreateShippingAvailabilityConfigRequest} [createShippingAvailabilityConfigRequest] Create shippingAvailabilityConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShippingAvailabilityConfig: function (createShippingAvailabilityConfigRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createShippingAvailabilityConfig(createShippingAvailabilityConfigRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a shippingAvailabilityPartnerConfig
         * @param {CreateShippingAvailabilityPartnerConfigRequest} [createShippingAvailabilityPartnerConfigRequest] Create shippingAvailabilityPartnerConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShippingAvailabilityPartnerConfig: function (createShippingAvailabilityPartnerConfigRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createShippingAvailabilityPartnerConfig(createShippingAvailabilityPartnerConfigRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a shippingAvailabilityProductConfig
         * @param {CreateShippingAvailabilityProductConfigRequest} [createShippingAvailabilityProductConfigRequest] Create shippingAvailabilityProductConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShippingAvailabilityProductConfig: function (createShippingAvailabilityProductConfigRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createShippingAvailabilityProductConfig(createShippingAvailabilityProductConfigRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a tag
         * @param {CreateTagRequest} [createTagRequest] Create tag request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag: function (createTagRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createTag(createTagRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a catalog if no longer in use
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalog: function (catalogLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCatalog(catalogLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a catalogGroup if there are no products associated
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogGroup: function (catalogGroupLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCatalogGroup(catalogGroupLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary delete existing liquidation linked to a specific catalog group product
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {string} catalogProductLogicId catalog product logic id
         * @param {string} liquidationLogicId liquidation logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogGroupProductLiquidation: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCatalogGroupProductLiquidation(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a catalog/project association
         * @param {string} projectLogicId project logic id
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogProjectAssociation: function (projectLogicId, catalogLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCatalogProjectAssociation(projectLogicId, catalogLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a catalogSector if no longer in use
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogSectorLogicId catalog-sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogSectorAssociation: function (catalogLogicId, catalogSectorLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCatalogSectorAssociation(catalogLogicId, catalogSectorLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a courierTenantProject if there are no associated
         * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCourierTenantProjectPartner: function (courierTenantProjectLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteCourierTenantProjectPartner(courierTenantProjectLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete resource if unrelated
         * @param {string} pricingModelLogicId PricingModel logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePricingModel: function (pricingModelLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePricingModel(pricingModelLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a sector if there are no products associated
         * @param {string} sectorLogicId sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSector: function (sectorLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSector(sectorLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a shippingAvailabilityConfig if there are no associated
         * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShippingAvailabilityConfig: function (shippingAvailabilityConfigLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteShippingAvailabilityConfig(shippingAvailabilityConfigLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a shippingAvailabilityPartnerConfig if there are no associated
         * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShippingAvailabilityPartnerConfig: function (shippingAvailabilityPartnerConfigLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteShippingAvailabilityPartnerConfig(shippingAvailabilityPartnerConfigLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a shippingAvailabilityProductConfig if there are no associated
         * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShippingAvailabilityProductConfig: function (shippingAvailabilityProductConfigLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteShippingAvailabilityProductConfig(shippingAvailabilityProductConfigLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Deletes a tag if there are no products associated
         * @param {string} tagLogicId tag logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag: function (tagLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteTag(tagLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalog
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalog: function (catalogLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalog(catalogLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalogGroup
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGroup: function (catalogGroupLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogGroup(catalogGroupLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalogGroup products
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGroupProducts: function (catalogLogicId, catalogGroupLogicId, page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogGroupProducts(catalogLogicId, catalogGroupLogicId, page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged catalogGroups filtered by input parameters
         * @param {string} catalogLogicId catalog logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGroups: function (catalogLogicId, page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogGroups(catalogLogicId, page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalogProduct
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogProductLogicId catalogProduct logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogProduct: function (catalogLogicId, catalogProductLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogProduct(catalogLogicId, catalogProductLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged catalogProducts filtered by input parameters
         * @param {string} catalogLogicId catalog logic id
         * @param {Array<string>} [notInCatalogGroupLogicIds] list of catalog-groups (logicId) to exclude
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogProducts: function (catalogLogicId, notInCatalogGroupLogicIds, page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogProducts(catalogLogicId, notInCatalogGroupLogicIds, page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalog/project association
         * @param {string} projectLogicId project logic id
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogProjectAssociation: function (projectLogicId, catalogLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogProjectAssociation(projectLogicId, catalogLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a catalogSector
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogSectorLogicId catalog-sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogSector: function (catalogLogicId, catalogSectorLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogSector(catalogLogicId, catalogSectorLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged catalogSectors filtered by input parameters
         * @param {string} catalogLogicId catalog logic id
         * @param {string} [sectorLogicId] sector logic id
         * @param {string} [sectorParentLogicId] sector parent logic id
         * @param {string} [catalogSectorLogicId] catalog-sector logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogSectors: function (catalogLogicId, sectorLogicId, sectorParentLogicId, catalogSectorLogicId, page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogSectors(catalogLogicId, sectorLogicId, sectorParentLogicId, catalogSectorLogicId, page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged catalogs filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogs: function (page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogs(page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged catalogs filtered by input parameters
         * @param {string} projectLogicId project logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogsProjectAssociation: function (projectLogicId, page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCatalogsProjectAssociation(projectLogicId, page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a sector
         * @param {string} sectorLogicId sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSector: function (sectorLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSector(sectorLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged sectors filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectors: function (page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSectors(page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a tag
         * @param {string} tagLogicId tag logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag: function (tagLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTag(tagLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged tags filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: function (page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTags(page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a courierTenantProjectPartner
         * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadCourierTenantProjectPartner: function (courierTenantProjectLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadCourierTenantProjectPartner(courierTenantProjectLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a pricingModel
         * @param {string} pricingModelLogicId PricingModel logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadPricingModel: function (pricingModelLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadPricingModel(pricingModelLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a shippingAvailabilityConfig
         * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadShippingAvailabilityConfig: function (shippingAvailabilityConfigLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadShippingAvailabilityConfig(shippingAvailabilityConfigLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a shippingAvailabilityPartnerConfig
         * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadShippingAvailabilityPartnerConfig: function (shippingAvailabilityPartnerConfigLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadShippingAvailabilityPartnerConfig(shippingAvailabilityPartnerConfigLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a shippingAvailabilityProductConfig
         * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadShippingAvailabilityProductConfig: function (shippingAvailabilityProductConfigLogicId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loadShippingAvailabilityProductConfig(shippingAvailabilityProductConfigLogicId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary modify status for a specific catalogGroup
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {CatalogGroupStatusRequest} catalogGroupStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCatalogGroupStatus: function (catalogGroupLogicId, catalogGroupStatusRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchCatalogGroupStatus(catalogGroupLogicId, catalogGroupStatusRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary modify status for a specific catalog
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogStatusRequest} catalogStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCatalogStatus: function (catalogLogicId, catalogStatusRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.patchCatalogStatus(catalogLogicId, catalogStatusRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged courierTenantProjectPartner filtered by input parameters
         * @param {string} tenantLogicId tenant logic id
         * @param {string} projectLogicId project logic id
         * @param {string} [courierLogicId] courier logic id
         * @param {string} [partnerLogicId] partner logic id
         * @param {string} [nationCode] nationCode
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCourierTenantProjectPartners: function (tenantLogicId, projectLogicId, courierLogicId, partnerLogicId, nationCode, page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchCourierTenantProjectPartners(tenantLogicId, projectLogicId, courierLogicId, partnerLogicId, nationCode, page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary search couriers
         * @param {string} [courierLogicId] courier logic ids
         * @param {string} [nationCode] nationCode to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCouriers: function (courierLogicId, nationCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchCouriers(courierLogicId, nationCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged pricingModels filtered by input parameters
         * @param {PricingModelTypeEnum} [type] type of the pricingModel param
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPricingModels: function (type, page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchPricingModels(type, page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged shippingAvailabilityConfigs filtered by input parameters
         * @param {string} [tenantLogicId] tenant logic id
         * @param {string} [projectLogicId] project logic id
         * @param {string} [catalogLogicId] catalog logic id
         * @param {Set<string>} [inProductLogicIds] list of product (logicId) to include
         * @param {Set<string>} [inPartnerLogicIds] list of partner (logicId) to include
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchShippingAvailabilityConfigs: function (tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, inPartnerLogicIds, page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchShippingAvailabilityConfigs(tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, inPartnerLogicIds, page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged shippingAvailabilityPartnerConfigs filtered by input parameters
         * @param {string} [tenantLogicId] tenant logic id
         * @param {string} [projectLogicId] project logic id
         * @param {string} [catalogLogicId] catalog logic id
         * @param {Set<string>} [inPartnerLogicIds] list of partner (logicId) to include
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchShippingAvailabilityPartnerConfigs: function (tenantLogicId, projectLogicId, catalogLogicId, inPartnerLogicIds, page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchShippingAvailabilityPartnerConfigs(tenantLogicId, projectLogicId, catalogLogicId, inPartnerLogicIds, page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves paged shippingAvailabilityProductConfigs filtered by input parameters
         * @param {string} [tenantLogicId] tenant logic id
         * @param {string} [projectLogicId] project logic id
         * @param {string} [catalogLogicId] catalog logic id
         * @param {Set<string>} [inProductLogicIds] list of product (logicId) to include
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchShippingAvailabilityProductConfigs: function (tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, page, size, includeMetadata, sort, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchShippingAvailabilityProductConfigs(tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, page, size, includeMetadata, sort, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates the billing id of a catalogTenantProject entity
         * @param {string} projectLogicId project logic id
         * @param {CatalogProjectAssociationRequest} [catalogProjectAssociationRequest] Create catalog/project association request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingCatalogProjectTenant: function (projectLogicId, catalogProjectAssociationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateBillingCatalogProjectTenant(projectLogicId, catalogProjectAssociationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a catalog
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogUpdateRequest} [catalogUpdateRequest] Update catalog request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalog: function (catalogLogicId, catalogUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCatalog(catalogLogicId, catalogUpdateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a catalogGroup
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {CatalogGroupUpdateRequest} [catalogGroupUpdateRequest] Update catalogGroup request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogGroup: function (catalogGroupLogicId, catalogGroupUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCatalogGroup(catalogGroupLogicId, catalogGroupUpdateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary update existing liquidation linked to a specific catalog group product
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {string} catalogProductLogicId catalog product logic id
         * @param {string} liquidationLogicId liquidation logic id
         * @param {LiquidationRequest} [liquidationRequest] Update liquidation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogGroupProductLiquidation: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, liquidationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCatalogGroupProductLiquidation(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, liquidationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a courierTenantProjectPartner
         * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
         * @param {UpdateCourierTenantProjectPartnerRequest} [updateCourierTenantProjectPartnerRequest] Update courierTenantProject request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCourierTenantProjectPartner: function (courierTenantProjectLogicId, updateCourierTenantProjectPartnerRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCourierTenantProjectPartner(courierTenantProjectLogicId, updateCourierTenantProjectPartnerRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a pricingModel
         * @param {string} pricingModelLogicId PricingModel logic id
         * @param {PricingModelRequest} [pricingModelRequest] Update pricingModel request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePricingModel: function (pricingModelLogicId, pricingModelRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePricingModel(pricingModelLogicId, pricingModelRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a sector
         * @param {string} sectorLogicId sector logic id
         * @param {UpdateSectorRequest} [updateSectorRequest] Update sector request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSector: function (sectorLogicId, updateSectorRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSector(sectorLogicId, updateSectorRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a shippingAvailabilityConfig
         * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
         * @param {UpdateShippingAvailabilityConfigRequest} [updateShippingAvailabilityConfigRequest] Update shippingAvailabilityConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAvailabilityConfig: function (shippingAvailabilityConfigLogicId, updateShippingAvailabilityConfigRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShippingAvailabilityConfig(shippingAvailabilityConfigLogicId, updateShippingAvailabilityConfigRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a shippingAvailabilityPartnerConfig
         * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
         * @param {UpdateShippingAvailabilityPartnerConfigRequest} [updateShippingAvailabilityPartnerConfigRequest] Update shippingAvailabilityPartnerConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAvailabilityPartnerConfig: function (shippingAvailabilityPartnerConfigLogicId, updateShippingAvailabilityPartnerConfigRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShippingAvailabilityPartnerConfig(shippingAvailabilityPartnerConfigLogicId, updateShippingAvailabilityPartnerConfigRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a shippingAvailabilityProductConfig
         * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
         * @param {UpdateShippingAvailabilityProductConfigRequest} [updateShippingAvailabilityProductConfigRequest] Update shippingAvailabilityProductConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAvailabilityProductConfig: function (shippingAvailabilityProductConfigLogicId, updateShippingAvailabilityProductConfigRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateShippingAvailabilityProductConfig(shippingAvailabilityProductConfigLogicId, updateShippingAvailabilityProductConfigRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AdminCatalogueApiFp = AdminCatalogueApiFp;
/**
 * AdminCatalogueApi - factory interface
 * @export
 */
var AdminCatalogueApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AdminCatalogueApiFp)(configuration);
    return {
        /**
         *
         * @summary Add liquidation on CatalogGroupProduct
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {string} catalogProductLogicId catalog product logic id
         * @param {LiquidationRequest} [liquidationRequest] Add liquidation on catalogGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLiquidationOnCatalogGroupProduct: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationRequest, options) {
            return localVarFp.addLiquidationOnCatalogGroupProduct(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates and associate catalogAvailability to catalogGroupLogicId
         * @param {string} catalogLogicId
         * @param {string} catalogGroupLogicId
         * @param {string} catalogProductLogicId
         * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Creates and associate catalogAvailability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateAndAssociateCatalogAvailability: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, catalogAvailabilityDto, options) {
            return localVarFp.adminCreateAndAssociateCatalogAvailability(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, catalogAvailabilityDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a catalogAvailability
         * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Creates a catalogAvailability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCatalogAvailability: function (catalogAvailabilityDto, options) {
            return localVarFp.adminCreateCatalogAvailability(catalogAvailabilityDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a catalogProduct-Sector
         * @param {CatalogProductSectorData} [catalogProductSectorData] Create initiative request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCatalogProductSector: function (catalogProductSectorData, options) {
            return localVarFp.adminCreateCatalogProductSector(catalogProductSectorData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a catalog product tag
         * @param {CatalogProductTagDto} [catalogProductTagDto] Create catalog product tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCatalogProductTag: function (catalogProductTagDto, options) {
            return localVarFp.adminCreateCatalogProductTag(catalogProductTagDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary delete catalog availability
         * @param {string} logicId logicId of the product catalog availability to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCatalogAvailability: function (logicId, options) {
            return localVarFp.adminDeleteCatalogAvailability(logicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary delete catalog product sector
         * @param {string} catalogLogicId the logic id of the catalog
         * @param {string} sectorLogicId the logic id of the sector
         * @param {string} catalogProductLogicId the logic id of the catalog product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCatalogProductSector: function (catalogLogicId, sectorLogicId, catalogProductLogicId, options) {
            return localVarFp.adminDeleteCatalogProductSector(catalogLogicId, sectorLogicId, catalogProductLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary delete catalog product tag
         * @param {string} catalogProductLogicId logicId of the catalog product tag
         * @param {string} tagLogicId logicId of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCatalogProductTag: function (catalogProductLogicId, tagLogicId, options) {
            return localVarFp.adminDeleteCatalogProductTag(catalogProductLogicId, tagLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves catalog availability
         * @param {string} logicId the logic id of the catalog availability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCatalogAvailability: function (logicId, options) {
            return localVarFp.adminGetCatalogAvailability(logicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves single catalog sector product
         * @param {string} catalogLogicId the logic id of the catalog
         * @param {string} sectorLogicId the logic id of the sector
         * @param {string} catalogProductLogicId the logic id of the catalog product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCatalogProductSector: function (catalogLogicId, sectorLogicId, catalogProductLogicId, options) {
            return localVarFp.adminGetCatalogProductSector(catalogLogicId, sectorLogicId, catalogProductLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves single catalog product tag
         * @param {string} catalogProductLogicId the logic id of the catalog product
         * @param {string} tagLogicId the logic id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetCatalogProductTag: function (catalogProductLogicId, tagLogicId, options) {
            return localVarFp.adminGetCatalogProductTag(catalogProductLogicId, tagLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary search a catalog availability
         * @param {Array<string>} [logicId] search a catalog availability
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCatalogAvailability: function (logicId, page, size, options) {
            return localVarFp.adminSearchCatalogAvailability(logicId, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary get catalog product tag
         * @param {Array<string>} [catalogProductLogicId] the logic id of the catalog product
         * @param {Array<string>} [tagLogicId] the logic id of the tag
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCatalogProductTag: function (catalogProductLogicId, tagLogicId, page, size, options) {
            return localVarFp.adminSearchCatalogProductTag(catalogProductLogicId, tagLogicId, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary search catalog sector product
         * @param {Array<string>} [catalogLogicId] the logic id of the catalog
         * @param {Array<string>} [catalogProductLogicId] the logic id of the catalog product
         * @param {Array<string>} [sectorLogicId] the logic id of the catalog sector
         * @param {number} [page] Current page number
         * @param {number} [size] Limits the number of returned items
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchCatalogSectorProduct: function (catalogLogicId, catalogProductLogicId, sectorLogicId, page, size, options) {
            return localVarFp.adminSearchCatalogSectorProduct(catalogLogicId, catalogProductLogicId, sectorLogicId, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary update catalog availability
         * @param {string} logicId logicId of the product catalog availability to update
         * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Update supplier request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCatalogAvailability: function (logicId, catalogAvailabilityDto, options) {
            return localVarFp.adminUpdateCatalogAvailability(logicId, catalogAvailabilityDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a catalog
         * @param {CatalogCreateRequest} [catalogCreateRequest] Create catalog request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalog: function (catalogCreateRequest, options) {
            return localVarFp.createCatalog(catalogCreateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a catalogGroup
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogGroupCreateRequest} [catalogGroupCreateRequest] Create catalogGroup request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogGroup: function (catalogLogicId, catalogGroupCreateRequest, options) {
            return localVarFp.createCatalogGroup(catalogLogicId, catalogGroupCreateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a catalog/project association
         * @param {string} projectLogicId project logic id
         * @param {CatalogProjectAssociationRequest} [catalogProjectAssociationRequest] Create catalog/project association request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogProjectAssociation: function (projectLogicId, catalogProjectAssociationRequest, options) {
            return localVarFp.createCatalogProjectAssociation(projectLogicId, catalogProjectAssociationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a catalog/sector association
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogSectorAssociationRequest} [catalogSectorAssociationRequest] Create catalogSector request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogSectorAssociation: function (catalogLogicId, catalogSectorAssociationRequest, options) {
            return localVarFp.createCatalogSectorAssociation(catalogLogicId, catalogSectorAssociationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a courierTenantProjectPartners
         * @param {CreateCourierTenantProjectPartnerMassiveRequest} [createCourierTenantProjectPartnerMassiveRequest] Create courierTenantProject request (Massive)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCourierTenantProjectPartners: function (createCourierTenantProjectPartnerMassiveRequest, options) {
            return localVarFp.createCourierTenantProjectPartners(createCourierTenantProjectPartnerMassiveRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a PricingModel
         * @param {PricingModelRequest} [pricingModelRequest] Create PricingModel request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPricingModel: function (pricingModelRequest, options) {
            return localVarFp.createPricingModel(pricingModelRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a sector
         * @param {CreateSectorRequest} [createSectorRequest] Create sector request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSector: function (createSectorRequest, options) {
            return localVarFp.createSector(createSectorRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a shippingAvailabilityConfig
         * @param {CreateShippingAvailabilityConfigRequest} [createShippingAvailabilityConfigRequest] Create shippingAvailabilityConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShippingAvailabilityConfig: function (createShippingAvailabilityConfigRequest, options) {
            return localVarFp.createShippingAvailabilityConfig(createShippingAvailabilityConfigRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a shippingAvailabilityPartnerConfig
         * @param {CreateShippingAvailabilityPartnerConfigRequest} [createShippingAvailabilityPartnerConfigRequest] Create shippingAvailabilityPartnerConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShippingAvailabilityPartnerConfig: function (createShippingAvailabilityPartnerConfigRequest, options) {
            return localVarFp.createShippingAvailabilityPartnerConfig(createShippingAvailabilityPartnerConfigRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a shippingAvailabilityProductConfig
         * @param {CreateShippingAvailabilityProductConfigRequest} [createShippingAvailabilityProductConfigRequest] Create shippingAvailabilityProductConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShippingAvailabilityProductConfig: function (createShippingAvailabilityProductConfigRequest, options) {
            return localVarFp.createShippingAvailabilityProductConfig(createShippingAvailabilityProductConfigRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a tag
         * @param {CreateTagRequest} [createTagRequest] Create tag request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTag: function (createTagRequest, options) {
            return localVarFp.createTag(createTagRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a catalog if no longer in use
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalog: function (catalogLogicId, options) {
            return localVarFp.deleteCatalog(catalogLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a catalogGroup if there are no products associated
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogGroup: function (catalogGroupLogicId, options) {
            return localVarFp.deleteCatalogGroup(catalogGroupLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary delete existing liquidation linked to a specific catalog group product
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {string} catalogProductLogicId catalog product logic id
         * @param {string} liquidationLogicId liquidation logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogGroupProductLiquidation: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, options) {
            return localVarFp.deleteCatalogGroupProductLiquidation(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a catalog/project association
         * @param {string} projectLogicId project logic id
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogProjectAssociation: function (projectLogicId, catalogLogicId, options) {
            return localVarFp.deleteCatalogProjectAssociation(projectLogicId, catalogLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a catalogSector if no longer in use
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogSectorLogicId catalog-sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogSectorAssociation: function (catalogLogicId, catalogSectorLogicId, options) {
            return localVarFp.deleteCatalogSectorAssociation(catalogLogicId, catalogSectorLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a courierTenantProject if there are no associated
         * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCourierTenantProjectPartner: function (courierTenantProjectLogicId, options) {
            return localVarFp.deleteCourierTenantProjectPartner(courierTenantProjectLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete resource if unrelated
         * @param {string} pricingModelLogicId PricingModel logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePricingModel: function (pricingModelLogicId, options) {
            return localVarFp.deletePricingModel(pricingModelLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a sector if there are no products associated
         * @param {string} sectorLogicId sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSector: function (sectorLogicId, options) {
            return localVarFp.deleteSector(sectorLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a shippingAvailabilityConfig if there are no associated
         * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShippingAvailabilityConfig: function (shippingAvailabilityConfigLogicId, options) {
            return localVarFp.deleteShippingAvailabilityConfig(shippingAvailabilityConfigLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a shippingAvailabilityPartnerConfig if there are no associated
         * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShippingAvailabilityPartnerConfig: function (shippingAvailabilityPartnerConfigLogicId, options) {
            return localVarFp.deleteShippingAvailabilityPartnerConfig(shippingAvailabilityPartnerConfigLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a shippingAvailabilityProductConfig if there are no associated
         * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShippingAvailabilityProductConfig: function (shippingAvailabilityProductConfigLogicId, options) {
            return localVarFp.deleteShippingAvailabilityProductConfig(shippingAvailabilityProductConfigLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Deletes a tag if there are no products associated
         * @param {string} tagLogicId tag logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTag: function (tagLogicId, options) {
            return localVarFp.deleteTag(tagLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a catalog
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalog: function (catalogLogicId, options) {
            return localVarFp.getCatalog(catalogLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a catalogGroup
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGroup: function (catalogGroupLogicId, options) {
            return localVarFp.getCatalogGroup(catalogGroupLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a catalogGroup products
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGroupProducts: function (catalogLogicId, catalogGroupLogicId, page, size, includeMetadata, sort, options) {
            return localVarFp.getCatalogGroupProducts(catalogLogicId, catalogGroupLogicId, page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged catalogGroups filtered by input parameters
         * @param {string} catalogLogicId catalog logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogGroups: function (catalogLogicId, page, size, includeMetadata, sort, options) {
            return localVarFp.getCatalogGroups(catalogLogicId, page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a catalogProduct
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogProductLogicId catalogProduct logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogProduct: function (catalogLogicId, catalogProductLogicId, options) {
            return localVarFp.getCatalogProduct(catalogLogicId, catalogProductLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged catalogProducts filtered by input parameters
         * @param {string} catalogLogicId catalog logic id
         * @param {Array<string>} [notInCatalogGroupLogicIds] list of catalog-groups (logicId) to exclude
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogProducts: function (catalogLogicId, notInCatalogGroupLogicIds, page, size, includeMetadata, sort, options) {
            return localVarFp.getCatalogProducts(catalogLogicId, notInCatalogGroupLogicIds, page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a catalog/project association
         * @param {string} projectLogicId project logic id
         * @param {string} catalogLogicId catalog logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogProjectAssociation: function (projectLogicId, catalogLogicId, options) {
            return localVarFp.getCatalogProjectAssociation(projectLogicId, catalogLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a catalogSector
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogSectorLogicId catalog-sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogSector: function (catalogLogicId, catalogSectorLogicId, options) {
            return localVarFp.getCatalogSector(catalogLogicId, catalogSectorLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged catalogSectors filtered by input parameters
         * @param {string} catalogLogicId catalog logic id
         * @param {string} [sectorLogicId] sector logic id
         * @param {string} [sectorParentLogicId] sector parent logic id
         * @param {string} [catalogSectorLogicId] catalog-sector logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogSectors: function (catalogLogicId, sectorLogicId, sectorParentLogicId, catalogSectorLogicId, page, size, includeMetadata, sort, options) {
            return localVarFp.getCatalogSectors(catalogLogicId, sectorLogicId, sectorParentLogicId, catalogSectorLogicId, page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged catalogs filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogs: function (page, size, includeMetadata, sort, options) {
            return localVarFp.getCatalogs(page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged catalogs filtered by input parameters
         * @param {string} projectLogicId project logic id
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogsProjectAssociation: function (projectLogicId, page, size, includeMetadata, sort, options) {
            return localVarFp.getCatalogsProjectAssociation(projectLogicId, page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a sector
         * @param {string} sectorLogicId sector logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSector: function (sectorLogicId, options) {
            return localVarFp.getSector(sectorLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged sectors filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectors: function (page, size, includeMetadata, sort, options) {
            return localVarFp.getSectors(page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a tag
         * @param {string} tagLogicId tag logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTag: function (tagLogicId, options) {
            return localVarFp.getTag(tagLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged tags filtered by input parameters
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: function (page, size, includeMetadata, sort, options) {
            return localVarFp.getTags(page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a courierTenantProjectPartner
         * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadCourierTenantProjectPartner: function (courierTenantProjectLogicId, options) {
            return localVarFp.loadCourierTenantProjectPartner(courierTenantProjectLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a pricingModel
         * @param {string} pricingModelLogicId PricingModel logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadPricingModel: function (pricingModelLogicId, options) {
            return localVarFp.loadPricingModel(pricingModelLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a shippingAvailabilityConfig
         * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadShippingAvailabilityConfig: function (shippingAvailabilityConfigLogicId, options) {
            return localVarFp.loadShippingAvailabilityConfig(shippingAvailabilityConfigLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a shippingAvailabilityPartnerConfig
         * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadShippingAvailabilityPartnerConfig: function (shippingAvailabilityPartnerConfigLogicId, options) {
            return localVarFp.loadShippingAvailabilityPartnerConfig(shippingAvailabilityPartnerConfigLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a shippingAvailabilityProductConfig
         * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadShippingAvailabilityProductConfig: function (shippingAvailabilityProductConfigLogicId, options) {
            return localVarFp.loadShippingAvailabilityProductConfig(shippingAvailabilityProductConfigLogicId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary modify status for a specific catalogGroup
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {CatalogGroupStatusRequest} catalogGroupStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCatalogGroupStatus: function (catalogGroupLogicId, catalogGroupStatusRequest, options) {
            return localVarFp.patchCatalogGroupStatus(catalogGroupLogicId, catalogGroupStatusRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary modify status for a specific catalog
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogStatusRequest} catalogStatusRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCatalogStatus: function (catalogLogicId, catalogStatusRequest, options) {
            return localVarFp.patchCatalogStatus(catalogLogicId, catalogStatusRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged courierTenantProjectPartner filtered by input parameters
         * @param {string} tenantLogicId tenant logic id
         * @param {string} projectLogicId project logic id
         * @param {string} [courierLogicId] courier logic id
         * @param {string} [partnerLogicId] partner logic id
         * @param {string} [nationCode] nationCode
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCourierTenantProjectPartners: function (tenantLogicId, projectLogicId, courierLogicId, partnerLogicId, nationCode, page, size, includeMetadata, sort, options) {
            return localVarFp.searchCourierTenantProjectPartners(tenantLogicId, projectLogicId, courierLogicId, partnerLogicId, nationCode, page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary search couriers
         * @param {string} [courierLogicId] courier logic ids
         * @param {string} [nationCode] nationCode to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCouriers: function (courierLogicId, nationCode, options) {
            return localVarFp.searchCouriers(courierLogicId, nationCode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged pricingModels filtered by input parameters
         * @param {PricingModelTypeEnum} [type] type of the pricingModel param
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPricingModels: function (type, page, size, includeMetadata, sort, options) {
            return localVarFp.searchPricingModels(type, page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged shippingAvailabilityConfigs filtered by input parameters
         * @param {string} [tenantLogicId] tenant logic id
         * @param {string} [projectLogicId] project logic id
         * @param {string} [catalogLogicId] catalog logic id
         * @param {Set<string>} [inProductLogicIds] list of product (logicId) to include
         * @param {Set<string>} [inPartnerLogicIds] list of partner (logicId) to include
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchShippingAvailabilityConfigs: function (tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, inPartnerLogicIds, page, size, includeMetadata, sort, options) {
            return localVarFp.searchShippingAvailabilityConfigs(tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, inPartnerLogicIds, page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged shippingAvailabilityPartnerConfigs filtered by input parameters
         * @param {string} [tenantLogicId] tenant logic id
         * @param {string} [projectLogicId] project logic id
         * @param {string} [catalogLogicId] catalog logic id
         * @param {Set<string>} [inPartnerLogicIds] list of partner (logicId) to include
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchShippingAvailabilityPartnerConfigs: function (tenantLogicId, projectLogicId, catalogLogicId, inPartnerLogicIds, page, size, includeMetadata, sort, options) {
            return localVarFp.searchShippingAvailabilityPartnerConfigs(tenantLogicId, projectLogicId, catalogLogicId, inPartnerLogicIds, page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves paged shippingAvailabilityProductConfigs filtered by input parameters
         * @param {string} [tenantLogicId] tenant logic id
         * @param {string} [projectLogicId] project logic id
         * @param {string} [catalogLogicId] catalog logic id
         * @param {Set<string>} [inProductLogicIds] list of product (logicId) to include
         * @param {number} [page] requested page number
         * @param {number} [size] requested result page size
         * @param {boolean} [includeMetadata] requested metadata for pagination
         * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchShippingAvailabilityProductConfigs: function (tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, page, size, includeMetadata, sort, options) {
            return localVarFp.searchShippingAvailabilityProductConfigs(tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, page, size, includeMetadata, sort, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates the billing id of a catalogTenantProject entity
         * @param {string} projectLogicId project logic id
         * @param {CatalogProjectAssociationRequest} [catalogProjectAssociationRequest] Create catalog/project association request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingCatalogProjectTenant: function (projectLogicId, catalogProjectAssociationRequest, options) {
            return localVarFp.updateBillingCatalogProjectTenant(projectLogicId, catalogProjectAssociationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a catalog
         * @param {string} catalogLogicId catalog logic id
         * @param {CatalogUpdateRequest} [catalogUpdateRequest] Update catalog request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalog: function (catalogLogicId, catalogUpdateRequest, options) {
            return localVarFp.updateCatalog(catalogLogicId, catalogUpdateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a catalogGroup
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {CatalogGroupUpdateRequest} [catalogGroupUpdateRequest] Update catalogGroup request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogGroup: function (catalogGroupLogicId, catalogGroupUpdateRequest, options) {
            return localVarFp.updateCatalogGroup(catalogGroupLogicId, catalogGroupUpdateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary update existing liquidation linked to a specific catalog group product
         * @param {string} catalogLogicId catalog logic id
         * @param {string} catalogGroupLogicId catalogGroup logic id
         * @param {string} catalogProductLogicId catalog product logic id
         * @param {string} liquidationLogicId liquidation logic id
         * @param {LiquidationRequest} [liquidationRequest] Update liquidation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogGroupProductLiquidation: function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, liquidationRequest, options) {
            return localVarFp.updateCatalogGroupProductLiquidation(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, liquidationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a courierTenantProjectPartner
         * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
         * @param {UpdateCourierTenantProjectPartnerRequest} [updateCourierTenantProjectPartnerRequest] Update courierTenantProject request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCourierTenantProjectPartner: function (courierTenantProjectLogicId, updateCourierTenantProjectPartnerRequest, options) {
            return localVarFp.updateCourierTenantProjectPartner(courierTenantProjectLogicId, updateCourierTenantProjectPartnerRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a pricingModel
         * @param {string} pricingModelLogicId PricingModel logic id
         * @param {PricingModelRequest} [pricingModelRequest] Update pricingModel request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePricingModel: function (pricingModelLogicId, pricingModelRequest, options) {
            return localVarFp.updatePricingModel(pricingModelLogicId, pricingModelRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a sector
         * @param {string} sectorLogicId sector logic id
         * @param {UpdateSectorRequest} [updateSectorRequest] Update sector request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSector: function (sectorLogicId, updateSectorRequest, options) {
            return localVarFp.updateSector(sectorLogicId, updateSectorRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a shippingAvailabilityConfig
         * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
         * @param {UpdateShippingAvailabilityConfigRequest} [updateShippingAvailabilityConfigRequest] Update shippingAvailabilityConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAvailabilityConfig: function (shippingAvailabilityConfigLogicId, updateShippingAvailabilityConfigRequest, options) {
            return localVarFp.updateShippingAvailabilityConfig(shippingAvailabilityConfigLogicId, updateShippingAvailabilityConfigRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a shippingAvailabilityPartnerConfig
         * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
         * @param {UpdateShippingAvailabilityPartnerConfigRequest} [updateShippingAvailabilityPartnerConfigRequest] Update shippingAvailabilityPartnerConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAvailabilityPartnerConfig: function (shippingAvailabilityPartnerConfigLogicId, updateShippingAvailabilityPartnerConfigRequest, options) {
            return localVarFp.updateShippingAvailabilityPartnerConfig(shippingAvailabilityPartnerConfigLogicId, updateShippingAvailabilityPartnerConfigRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a shippingAvailabilityProductConfig
         * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
         * @param {UpdateShippingAvailabilityProductConfigRequest} [updateShippingAvailabilityProductConfigRequest] Update shippingAvailabilityProductConfig request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShippingAvailabilityProductConfig: function (shippingAvailabilityProductConfigLogicId, updateShippingAvailabilityProductConfigRequest, options) {
            return localVarFp.updateShippingAvailabilityProductConfig(shippingAvailabilityProductConfigLogicId, updateShippingAvailabilityProductConfigRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AdminCatalogueApiFactory = AdminCatalogueApiFactory;
/**
 * AdminCatalogueApi - object-oriented interface
 * @export
 * @class AdminCatalogueApi
 * @extends {BaseAPI}
 */
var AdminCatalogueApi = /** @class */ (function (_super) {
    __extends(AdminCatalogueApi, _super);
    function AdminCatalogueApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Add liquidation on CatalogGroupProduct
     * @param {string} catalogLogicId catalog logic id
     * @param {string} catalogGroupLogicId catalogGroup logic id
     * @param {string} catalogProductLogicId catalog product logic id
     * @param {LiquidationRequest} [liquidationRequest] Add liquidation on catalogGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.addLiquidationOnCatalogGroupProduct = function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).addLiquidationOnCatalogGroupProduct(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates and associate catalogAvailability to catalogGroupLogicId
     * @param {string} catalogLogicId
     * @param {string} catalogGroupLogicId
     * @param {string} catalogProductLogicId
     * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Creates and associate catalogAvailability
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminCreateAndAssociateCatalogAvailability = function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, catalogAvailabilityDto, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminCreateAndAssociateCatalogAvailability(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, catalogAvailabilityDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a catalogAvailability
     * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Creates a catalogAvailability
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminCreateCatalogAvailability = function (catalogAvailabilityDto, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminCreateCatalogAvailability(catalogAvailabilityDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a catalogProduct-Sector
     * @param {CatalogProductSectorData} [catalogProductSectorData] Create initiative request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminCreateCatalogProductSector = function (catalogProductSectorData, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminCreateCatalogProductSector(catalogProductSectorData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a catalog product tag
     * @param {CatalogProductTagDto} [catalogProductTagDto] Create catalog product tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminCreateCatalogProductTag = function (catalogProductTagDto, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminCreateCatalogProductTag(catalogProductTagDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary delete catalog availability
     * @param {string} logicId logicId of the product catalog availability to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminDeleteCatalogAvailability = function (logicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminDeleteCatalogAvailability(logicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary delete catalog product sector
     * @param {string} catalogLogicId the logic id of the catalog
     * @param {string} sectorLogicId the logic id of the sector
     * @param {string} catalogProductLogicId the logic id of the catalog product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminDeleteCatalogProductSector = function (catalogLogicId, sectorLogicId, catalogProductLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminDeleteCatalogProductSector(catalogLogicId, sectorLogicId, catalogProductLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary delete catalog product tag
     * @param {string} catalogProductLogicId logicId of the catalog product tag
     * @param {string} tagLogicId logicId of the tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminDeleteCatalogProductTag = function (catalogProductLogicId, tagLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminDeleteCatalogProductTag(catalogProductLogicId, tagLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves catalog availability
     * @param {string} logicId the logic id of the catalog availability
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminGetCatalogAvailability = function (logicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminGetCatalogAvailability(logicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves single catalog sector product
     * @param {string} catalogLogicId the logic id of the catalog
     * @param {string} sectorLogicId the logic id of the sector
     * @param {string} catalogProductLogicId the logic id of the catalog product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminGetCatalogProductSector = function (catalogLogicId, sectorLogicId, catalogProductLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminGetCatalogProductSector(catalogLogicId, sectorLogicId, catalogProductLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves single catalog product tag
     * @param {string} catalogProductLogicId the logic id of the catalog product
     * @param {string} tagLogicId the logic id of the tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminGetCatalogProductTag = function (catalogProductLogicId, tagLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminGetCatalogProductTag(catalogProductLogicId, tagLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary search a catalog availability
     * @param {Array<string>} [logicId] search a catalog availability
     * @param {number} [page] Current page number
     * @param {number} [size] Limits the number of returned items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminSearchCatalogAvailability = function (logicId, page, size, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminSearchCatalogAvailability(logicId, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary get catalog product tag
     * @param {Array<string>} [catalogProductLogicId] the logic id of the catalog product
     * @param {Array<string>} [tagLogicId] the logic id of the tag
     * @param {number} [page] Current page number
     * @param {number} [size] Limits the number of returned items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminSearchCatalogProductTag = function (catalogProductLogicId, tagLogicId, page, size, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminSearchCatalogProductTag(catalogProductLogicId, tagLogicId, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary search catalog sector product
     * @param {Array<string>} [catalogLogicId] the logic id of the catalog
     * @param {Array<string>} [catalogProductLogicId] the logic id of the catalog product
     * @param {Array<string>} [sectorLogicId] the logic id of the catalog sector
     * @param {number} [page] Current page number
     * @param {number} [size] Limits the number of returned items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminSearchCatalogSectorProduct = function (catalogLogicId, catalogProductLogicId, sectorLogicId, page, size, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminSearchCatalogSectorProduct(catalogLogicId, catalogProductLogicId, sectorLogicId, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary update catalog availability
     * @param {string} logicId logicId of the product catalog availability to update
     * @param {CatalogAvailabilityDto} [catalogAvailabilityDto] Update supplier request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.adminUpdateCatalogAvailability = function (logicId, catalogAvailabilityDto, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).adminUpdateCatalogAvailability(logicId, catalogAvailabilityDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a catalog
     * @param {CatalogCreateRequest} [catalogCreateRequest] Create catalog request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createCatalog = function (catalogCreateRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createCatalog(catalogCreateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a catalogGroup
     * @param {string} catalogLogicId catalog logic id
     * @param {CatalogGroupCreateRequest} [catalogGroupCreateRequest] Create catalogGroup request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createCatalogGroup = function (catalogLogicId, catalogGroupCreateRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createCatalogGroup(catalogLogicId, catalogGroupCreateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a catalog/project association
     * @param {string} projectLogicId project logic id
     * @param {CatalogProjectAssociationRequest} [catalogProjectAssociationRequest] Create catalog/project association request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createCatalogProjectAssociation = function (projectLogicId, catalogProjectAssociationRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createCatalogProjectAssociation(projectLogicId, catalogProjectAssociationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a catalog/sector association
     * @param {string} catalogLogicId catalog logic id
     * @param {CatalogSectorAssociationRequest} [catalogSectorAssociationRequest] Create catalogSector request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createCatalogSectorAssociation = function (catalogLogicId, catalogSectorAssociationRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createCatalogSectorAssociation(catalogLogicId, catalogSectorAssociationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a courierTenantProjectPartners
     * @param {CreateCourierTenantProjectPartnerMassiveRequest} [createCourierTenantProjectPartnerMassiveRequest] Create courierTenantProject request (Massive)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createCourierTenantProjectPartners = function (createCourierTenantProjectPartnerMassiveRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createCourierTenantProjectPartners(createCourierTenantProjectPartnerMassiveRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a PricingModel
     * @param {PricingModelRequest} [pricingModelRequest] Create PricingModel request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createPricingModel = function (pricingModelRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createPricingModel(pricingModelRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a sector
     * @param {CreateSectorRequest} [createSectorRequest] Create sector request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createSector = function (createSectorRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createSector(createSectorRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a shippingAvailabilityConfig
     * @param {CreateShippingAvailabilityConfigRequest} [createShippingAvailabilityConfigRequest] Create shippingAvailabilityConfig request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createShippingAvailabilityConfig = function (createShippingAvailabilityConfigRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createShippingAvailabilityConfig(createShippingAvailabilityConfigRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a shippingAvailabilityPartnerConfig
     * @param {CreateShippingAvailabilityPartnerConfigRequest} [createShippingAvailabilityPartnerConfigRequest] Create shippingAvailabilityPartnerConfig request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createShippingAvailabilityPartnerConfig = function (createShippingAvailabilityPartnerConfigRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createShippingAvailabilityPartnerConfig(createShippingAvailabilityPartnerConfigRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a shippingAvailabilityProductConfig
     * @param {CreateShippingAvailabilityProductConfigRequest} [createShippingAvailabilityProductConfigRequest] Create shippingAvailabilityProductConfig request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createShippingAvailabilityProductConfig = function (createShippingAvailabilityProductConfigRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createShippingAvailabilityProductConfig(createShippingAvailabilityProductConfigRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a tag
     * @param {CreateTagRequest} [createTagRequest] Create tag request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.createTag = function (createTagRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).createTag(createTagRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a catalog if no longer in use
     * @param {string} catalogLogicId catalog logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteCatalog = function (catalogLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteCatalog(catalogLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a catalogGroup if there are no products associated
     * @param {string} catalogGroupLogicId catalogGroup logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteCatalogGroup = function (catalogGroupLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteCatalogGroup(catalogGroupLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary delete existing liquidation linked to a specific catalog group product
     * @param {string} catalogLogicId catalog logic id
     * @param {string} catalogGroupLogicId catalogGroup logic id
     * @param {string} catalogProductLogicId catalog product logic id
     * @param {string} liquidationLogicId liquidation logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteCatalogGroupProductLiquidation = function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteCatalogGroupProductLiquidation(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a catalog/project association
     * @param {string} projectLogicId project logic id
     * @param {string} catalogLogicId catalog logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteCatalogProjectAssociation = function (projectLogicId, catalogLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteCatalogProjectAssociation(projectLogicId, catalogLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a catalogSector if no longer in use
     * @param {string} catalogLogicId catalog logic id
     * @param {string} catalogSectorLogicId catalog-sector logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteCatalogSectorAssociation = function (catalogLogicId, catalogSectorLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteCatalogSectorAssociation(catalogLogicId, catalogSectorLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a courierTenantProject if there are no associated
     * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteCourierTenantProjectPartner = function (courierTenantProjectLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteCourierTenantProjectPartner(courierTenantProjectLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete resource if unrelated
     * @param {string} pricingModelLogicId PricingModel logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deletePricingModel = function (pricingModelLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deletePricingModel(pricingModelLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a sector if there are no products associated
     * @param {string} sectorLogicId sector logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteSector = function (sectorLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteSector(sectorLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a shippingAvailabilityConfig if there are no associated
     * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteShippingAvailabilityConfig = function (shippingAvailabilityConfigLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteShippingAvailabilityConfig(shippingAvailabilityConfigLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a shippingAvailabilityPartnerConfig if there are no associated
     * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteShippingAvailabilityPartnerConfig = function (shippingAvailabilityPartnerConfigLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteShippingAvailabilityPartnerConfig(shippingAvailabilityPartnerConfigLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a shippingAvailabilityProductConfig if there are no associated
     * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteShippingAvailabilityProductConfig = function (shippingAvailabilityProductConfigLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteShippingAvailabilityProductConfig(shippingAvailabilityProductConfigLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Deletes a tag if there are no products associated
     * @param {string} tagLogicId tag logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.deleteTag = function (tagLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).deleteTag(tagLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a catalog
     * @param {string} catalogLogicId catalog logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalog = function (catalogLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalog(catalogLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a catalogGroup
     * @param {string} catalogGroupLogicId catalogGroup logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalogGroup = function (catalogGroupLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalogGroup(catalogGroupLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a catalogGroup products
     * @param {string} catalogLogicId catalog logic id
     * @param {string} catalogGroupLogicId catalogGroup logic id
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalogGroupProducts = function (catalogLogicId, catalogGroupLogicId, page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalogGroupProducts(catalogLogicId, catalogGroupLogicId, page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged catalogGroups filtered by input parameters
     * @param {string} catalogLogicId catalog logic id
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalogGroups = function (catalogLogicId, page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalogGroups(catalogLogicId, page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a catalogProduct
     * @param {string} catalogLogicId catalog logic id
     * @param {string} catalogProductLogicId catalogProduct logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalogProduct = function (catalogLogicId, catalogProductLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalogProduct(catalogLogicId, catalogProductLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged catalogProducts filtered by input parameters
     * @param {string} catalogLogicId catalog logic id
     * @param {Array<string>} [notInCatalogGroupLogicIds] list of catalog-groups (logicId) to exclude
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalogProducts = function (catalogLogicId, notInCatalogGroupLogicIds, page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalogProducts(catalogLogicId, notInCatalogGroupLogicIds, page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a catalog/project association
     * @param {string} projectLogicId project logic id
     * @param {string} catalogLogicId catalog logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalogProjectAssociation = function (projectLogicId, catalogLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalogProjectAssociation(projectLogicId, catalogLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a catalogSector
     * @param {string} catalogLogicId catalog logic id
     * @param {string} catalogSectorLogicId catalog-sector logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalogSector = function (catalogLogicId, catalogSectorLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalogSector(catalogLogicId, catalogSectorLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged catalogSectors filtered by input parameters
     * @param {string} catalogLogicId catalog logic id
     * @param {string} [sectorLogicId] sector logic id
     * @param {string} [sectorParentLogicId] sector parent logic id
     * @param {string} [catalogSectorLogicId] catalog-sector logic id
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalogSectors = function (catalogLogicId, sectorLogicId, sectorParentLogicId, catalogSectorLogicId, page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalogSectors(catalogLogicId, sectorLogicId, sectorParentLogicId, catalogSectorLogicId, page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged catalogs filtered by input parameters
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalogs = function (page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalogs(page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged catalogs filtered by input parameters
     * @param {string} projectLogicId project logic id
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getCatalogsProjectAssociation = function (projectLogicId, page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getCatalogsProjectAssociation(projectLogicId, page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a sector
     * @param {string} sectorLogicId sector logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getSector = function (sectorLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getSector(sectorLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged sectors filtered by input parameters
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getSectors = function (page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getSectors(page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a tag
     * @param {string} tagLogicId tag logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getTag = function (tagLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getTag(tagLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged tags filtered by input parameters
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.getTags = function (page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).getTags(page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a courierTenantProjectPartner
     * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.loadCourierTenantProjectPartner = function (courierTenantProjectLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).loadCourierTenantProjectPartner(courierTenantProjectLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a pricingModel
     * @param {string} pricingModelLogicId PricingModel logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.loadPricingModel = function (pricingModelLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).loadPricingModel(pricingModelLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a shippingAvailabilityConfig
     * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.loadShippingAvailabilityConfig = function (shippingAvailabilityConfigLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).loadShippingAvailabilityConfig(shippingAvailabilityConfigLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a shippingAvailabilityPartnerConfig
     * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.loadShippingAvailabilityPartnerConfig = function (shippingAvailabilityPartnerConfigLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).loadShippingAvailabilityPartnerConfig(shippingAvailabilityPartnerConfigLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a shippingAvailabilityProductConfig
     * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.loadShippingAvailabilityProductConfig = function (shippingAvailabilityProductConfigLogicId, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).loadShippingAvailabilityProductConfig(shippingAvailabilityProductConfigLogicId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary modify status for a specific catalogGroup
     * @param {string} catalogGroupLogicId catalogGroup logic id
     * @param {CatalogGroupStatusRequest} catalogGroupStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.patchCatalogGroupStatus = function (catalogGroupLogicId, catalogGroupStatusRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).patchCatalogGroupStatus(catalogGroupLogicId, catalogGroupStatusRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary modify status for a specific catalog
     * @param {string} catalogLogicId catalog logic id
     * @param {CatalogStatusRequest} catalogStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.patchCatalogStatus = function (catalogLogicId, catalogStatusRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).patchCatalogStatus(catalogLogicId, catalogStatusRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged courierTenantProjectPartner filtered by input parameters
     * @param {string} tenantLogicId tenant logic id
     * @param {string} projectLogicId project logic id
     * @param {string} [courierLogicId] courier logic id
     * @param {string} [partnerLogicId] partner logic id
     * @param {string} [nationCode] nationCode
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.searchCourierTenantProjectPartners = function (tenantLogicId, projectLogicId, courierLogicId, partnerLogicId, nationCode, page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).searchCourierTenantProjectPartners(tenantLogicId, projectLogicId, courierLogicId, partnerLogicId, nationCode, page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary search couriers
     * @param {string} [courierLogicId] courier logic ids
     * @param {string} [nationCode] nationCode to search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.searchCouriers = function (courierLogicId, nationCode, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).searchCouriers(courierLogicId, nationCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged pricingModels filtered by input parameters
     * @param {PricingModelTypeEnum} [type] type of the pricingModel param
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.searchPricingModels = function (type, page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).searchPricingModels(type, page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged shippingAvailabilityConfigs filtered by input parameters
     * @param {string} [tenantLogicId] tenant logic id
     * @param {string} [projectLogicId] project logic id
     * @param {string} [catalogLogicId] catalog logic id
     * @param {Set<string>} [inProductLogicIds] list of product (logicId) to include
     * @param {Set<string>} [inPartnerLogicIds] list of partner (logicId) to include
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.searchShippingAvailabilityConfigs = function (tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, inPartnerLogicIds, page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).searchShippingAvailabilityConfigs(tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, inPartnerLogicIds, page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged shippingAvailabilityPartnerConfigs filtered by input parameters
     * @param {string} [tenantLogicId] tenant logic id
     * @param {string} [projectLogicId] project logic id
     * @param {string} [catalogLogicId] catalog logic id
     * @param {Set<string>} [inPartnerLogicIds] list of partner (logicId) to include
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.searchShippingAvailabilityPartnerConfigs = function (tenantLogicId, projectLogicId, catalogLogicId, inPartnerLogicIds, page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).searchShippingAvailabilityPartnerConfigs(tenantLogicId, projectLogicId, catalogLogicId, inPartnerLogicIds, page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves paged shippingAvailabilityProductConfigs filtered by input parameters
     * @param {string} [tenantLogicId] tenant logic id
     * @param {string} [projectLogicId] project logic id
     * @param {string} [catalogLogicId] catalog logic id
     * @param {Set<string>} [inProductLogicIds] list of product (logicId) to include
     * @param {number} [page] requested page number
     * @param {number} [size] requested result page size
     * @param {boolean} [includeMetadata] requested metadata for pagination
     * @param {Array<string>} [sort] list of sorting property names possibly preceded by \&#39;-\&#39; (DESC ordering). No prefix means ASC ordering To specify multiple values, repeat the param (e.g.: &amp;sort&#x3D;title&amp;sort&#x3D;-tag)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.searchShippingAvailabilityProductConfigs = function (tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, page, size, includeMetadata, sort, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).searchShippingAvailabilityProductConfigs(tenantLogicId, projectLogicId, catalogLogicId, inProductLogicIds, page, size, includeMetadata, sort, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates the billing id of a catalogTenantProject entity
     * @param {string} projectLogicId project logic id
     * @param {CatalogProjectAssociationRequest} [catalogProjectAssociationRequest] Create catalog/project association request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.updateBillingCatalogProjectTenant = function (projectLogicId, catalogProjectAssociationRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).updateBillingCatalogProjectTenant(projectLogicId, catalogProjectAssociationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a catalog
     * @param {string} catalogLogicId catalog logic id
     * @param {CatalogUpdateRequest} [catalogUpdateRequest] Update catalog request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.updateCatalog = function (catalogLogicId, catalogUpdateRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).updateCatalog(catalogLogicId, catalogUpdateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a catalogGroup
     * @param {string} catalogGroupLogicId catalogGroup logic id
     * @param {CatalogGroupUpdateRequest} [catalogGroupUpdateRequest] Update catalogGroup request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.updateCatalogGroup = function (catalogGroupLogicId, catalogGroupUpdateRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).updateCatalogGroup(catalogGroupLogicId, catalogGroupUpdateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary update existing liquidation linked to a specific catalog group product
     * @param {string} catalogLogicId catalog logic id
     * @param {string} catalogGroupLogicId catalogGroup logic id
     * @param {string} catalogProductLogicId catalog product logic id
     * @param {string} liquidationLogicId liquidation logic id
     * @param {LiquidationRequest} [liquidationRequest] Update liquidation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.updateCatalogGroupProductLiquidation = function (catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, liquidationRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).updateCatalogGroupProductLiquidation(catalogLogicId, catalogGroupLogicId, catalogProductLogicId, liquidationLogicId, liquidationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a courierTenantProjectPartner
     * @param {string} courierTenantProjectLogicId courierTenantProjects logic id
     * @param {UpdateCourierTenantProjectPartnerRequest} [updateCourierTenantProjectPartnerRequest] Update courierTenantProject request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.updateCourierTenantProjectPartner = function (courierTenantProjectLogicId, updateCourierTenantProjectPartnerRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).updateCourierTenantProjectPartner(courierTenantProjectLogicId, updateCourierTenantProjectPartnerRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a pricingModel
     * @param {string} pricingModelLogicId PricingModel logic id
     * @param {PricingModelRequest} [pricingModelRequest] Update pricingModel request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.updatePricingModel = function (pricingModelLogicId, pricingModelRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).updatePricingModel(pricingModelLogicId, pricingModelRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a sector
     * @param {string} sectorLogicId sector logic id
     * @param {UpdateSectorRequest} [updateSectorRequest] Update sector request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.updateSector = function (sectorLogicId, updateSectorRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).updateSector(sectorLogicId, updateSectorRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a shippingAvailabilityConfig
     * @param {string} shippingAvailabilityConfigLogicId shippingAvailabilityConfig logic id
     * @param {UpdateShippingAvailabilityConfigRequest} [updateShippingAvailabilityConfigRequest] Update shippingAvailabilityConfig request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.updateShippingAvailabilityConfig = function (shippingAvailabilityConfigLogicId, updateShippingAvailabilityConfigRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).updateShippingAvailabilityConfig(shippingAvailabilityConfigLogicId, updateShippingAvailabilityConfigRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a shippingAvailabilityPartnerConfig
     * @param {string} shippingAvailabilityPartnerConfigLogicId shippingAvailabilityPartnerConfig logic id
     * @param {UpdateShippingAvailabilityPartnerConfigRequest} [updateShippingAvailabilityPartnerConfigRequest] Update shippingAvailabilityPartnerConfig request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.updateShippingAvailabilityPartnerConfig = function (shippingAvailabilityPartnerConfigLogicId, updateShippingAvailabilityPartnerConfigRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).updateShippingAvailabilityPartnerConfig(shippingAvailabilityPartnerConfigLogicId, updateShippingAvailabilityPartnerConfigRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a shippingAvailabilityProductConfig
     * @param {string} shippingAvailabilityProductConfigLogicId shippingAvailabilityProductConfig logic id
     * @param {UpdateShippingAvailabilityProductConfigRequest} [updateShippingAvailabilityProductConfigRequest] Update shippingAvailabilityProductConfig request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogueApi
     */
    AdminCatalogueApi.prototype.updateShippingAvailabilityProductConfig = function (shippingAvailabilityProductConfigLogicId, updateShippingAvailabilityProductConfigRequest, options) {
        var _this = this;
        return (0, exports.AdminCatalogueApiFp)(this.configuration).updateShippingAvailabilityProductConfig(shippingAvailabilityProductConfigLogicId, updateShippingAvailabilityProductConfigRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AdminCatalogueApi;
}(base_1.BaseAPI));
exports.AdminCatalogueApi = AdminCatalogueApi;
